/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFacilityRegionRequest
 */
export interface UpdateFacilityRegionRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the UpdateFacilityRegionRequest interface.
 */
export function instanceOfUpdateFacilityRegionRequest(value: object): value is UpdateFacilityRegionRequest {
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    return true;
}

export function UpdateFacilityRegionRequestFromJSON(json: any): UpdateFacilityRegionRequest {
    return UpdateFacilityRegionRequestFromJSONTyped(json, false);
}

export function UpdateFacilityRegionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityRegionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function UpdateFacilityRegionRequestToJSON(json: any): UpdateFacilityRegionRequest {
    return UpdateFacilityRegionRequestToJSONTyped(json, false);
}

export function UpdateFacilityRegionRequestToJSONTyped(value?: UpdateFacilityRegionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'facility_ids': value['facility_ids'],
    };
}

